var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_9012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.3335C11.6696 1.33339 11.9936 1.46043 12.2403 1.68916C12.4869 1.91789 12.638 2.23139 12.6633 2.56683L12.6666 2.66683V4.00016C12.6669 4.80545 12.4588 5.59711 12.0624 6.29808C11.666 6.99904 11.0949 7.58543 10.4046 8.00016C11.0686 8.39897 11.6229 8.95693 12.0172 9.62364C12.4116 10.2903 12.6336 11.0448 12.6633 11.8188L12.6666 12.0002V13.3335C12.6667 13.6699 12.5396 13.9939 12.3109 14.2405C12.0822 14.4872 11.7687 14.6383 11.4333 14.6635L11.3333 14.6668H4.66659C4.3302 14.6669 4.00621 14.5399 3.75955 14.3112C3.5129 14.0824 3.36181 13.7689 3.33659 13.4335L3.33325 13.3335V12.0002C3.33289 11.1949 3.54104 10.4032 3.93744 9.70225C4.33384 9.00128 4.90497 8.41489 5.59525 8.00016C4.9312 7.60136 4.37697 7.0434 3.98262 6.37669C3.58828 5.70998 3.36625 4.95553 3.33659 4.1815L3.33325 4.00016V2.66683C3.33315 2.33045 3.46019 2.00645 3.68892 1.7598C3.91764 1.51314 4.23115 1.36206 4.56659 1.33683L4.66659 1.3335H11.3333Z",
    fill: "#7B5200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_9012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.d27feb23.svg";
export { ForwardRef as ReactComponent };